import { useEffect, useRef } from 'react';

// Skips the initial value so `values` loaded into an edit form are not wiped on mount.
export function useClearOnChange<V>(value: V, clear: (value: V) => void) {
  const previous = useRef(value);

  useEffect(() => {
    if (previous.current === value) {
      return;
    }

    previous.current = value;
    clear(value);
  }, [value, clear]);
}
